import template from "./effective-range-actions.html";
import "./effective-range-actions.less";

import { FORM_ENTITY_EFFECTIVE_RANGE } from "../../routes";
import { globs } from "../../services/globs";

function controller(
	$logger,
	$uibModal, 
	appState,
	api,
	toastr,
	loadingService,
	securityService
) {
	const ctrl = this;

	ctrl.$onInit = () => {
		ctrl.formId = appState.forms.selected.Id;
		
		ctrl.canDelete = securityService.isActionOrPatternAllowed(globs.entityTypes.byType(ctrl.entity.Type.Code).effective.byCode(ctrl.range.Scope || "*").delete);

		const now = new Date();
		const rangeStart = new Date(ctrl.range.Start);
		const rangeEnd = ctrl.range.End && new Date(ctrl.range.End);

		const canEdit = securityService.isActionOrPatternAllowed(globs.entityTypes.byType(ctrl.entity.Type.Code).effective.byCode(ctrl.range.Scope || "*").update);

		ctrl.canSet = canEdit === true
			&& rangeStart <= now
			&& (rangeEnd === undefined || rangeEnd > now);
	};

	ctrl.endNow = () => {
		const route = FORM_ENTITY_EFFECTIVE_RANGE(appState.forms.selected.Id, ctrl.entity.Id, ctrl.range.Id);

		const updated = {
			...ctrl.range,
			End: new Date().toISOString()
		};

		delete updated.statusClass;

		const promise = api.put(route,  updated)
			.then(() => {
				toastr.success("Effective range end was updated.");

				return ctrl.onRangeUpdate();
			});

		return loadingService.watch(promise);
	};

	ctrl.remove = () => {
		const route = FORM_ENTITY_EFFECTIVE_RANGE(appState.forms.selected.Id, ctrl.entity.Id, ctrl.range.Id);

		const promise = api.delete(route)
			.then(() => {
				toastr.success("Effective range was removed.");

				return ctrl.onRangeUpdate();
			})
			.catch((err) => {
				$logger.exception(err, "attempted to remove effective range", {
					range: ctrl.range, 
					entity: ctrl.entity
				});

				toastr.error(`${ctrl.entity.Name} failed to update.`);
			});

		return loadingService.watch(promise);
	};
}

export default angular
	.module("vesl.components.effective-range-actions", [])
	.component("effectiveRangeActions", {
		template,
		transclude: true,
		controller,
		bindings: {
			onRangeUpdate: "<",
			range: "=",
			entity: "<"
		}
	}).name;
